import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

document.querySelectorAll( '.etch-slider.swiper' ).forEach( ( el ) => {
	// Wrap .swiper-slide children in .swiper-wrapper (overlay stays outside)
	const slides = [ ...el.querySelectorAll( ':scope > .swiper-slide' ) ];
	if ( slides.length ) {
		const wrapper = document.createElement( 'div' );
		wrapper.className = 'swiper-wrapper';
		el.insertBefore( wrapper, slides[ 0 ] );
		slides.forEach( ( s ) => wrapper.appendChild( s ) );
	}

	const autoplay    = el.dataset.autoplay       === 'true';
	const delay       = parseInt( el.dataset.delay, 10 ) || 4000;
	const loop        = el.dataset.loop           === 'true';
	const showNav     = el.dataset.showNav        === 'true';
	const showPag     = el.dataset.showPagination === 'true';
	const effect      = el.dataset.effect         || 'slide';

	const modules = [];
	if ( showNav )  modules.push( Navigation );
	if ( showPag )  modules.push( Pagination );
	if ( autoplay ) modules.push( Autoplay );
	if ( effect === 'fade' ) modules.push( EffectFade );

	new Swiper( el, {
		modules,
		effect,
		loop,
		...(
			autoplay
				? { autoplay: { delay, disableOnInteraction: false } }
				: {}
		),
		...(
			showNav
				? { navigation: { prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' } }
				: {}
		),
		...(
			showPag
				? { pagination: { el: '.swiper-pagination', clickable: true } }
				: {}
		),
	} );
} );
